export default "__VITE_ASSET__zY1VUiun__"